<template>
<div class="z-main">
	<header class="z-header">
		<div><router-link to="/market"><img src="../../assets/sysbars/left.png" /></router-link></div>
		<div>交易</div>
		<div><router-link to="/my/publishBuyRecord">记录</router-link></div>
	</header>
	<div class="z-body">

		<div class="z-buy-input">
			<v-text-field :label="'交易数量（最大可买入QLC'+balance+'）'" :rules="rules" v-model="amount"></v-text-field>
		</div>
		<div class="z-padding-both">
			<p class="z-p">交易账户</p>
			<p class="z-p z-p-describe" style="margin-bottom: 10px;">
				银行：{{bank.bank_name}}<br>
				持卡人：{{bank.account_name}}<br>
				卡号：{{bank.account_number}}<br>
			</p>
			<p class="z-buy-rmb">
				银行转账金额：&yen;{{rmb}}
			</p>
			<p class="z-p">上传凭证</p>
			<div class="z-buy-imgs">
				<div v-for="(item,index) in imgsShow">
					<img :src="item"/>
				</div>
				<div>
					<img src="../../assets/market/upload.png"/>
					<input type="file" @change="imgUpload($event)">
				</div>
			</div>
			<p class="z-p">重要提醒</p>
			<p class="z-p z-p-describe" v-html="tips"></p>
			<div class="z-btn-box">
				<div class="z-btn-long z-full-width" style="border-radius: 0px;" @click="onpost">购买</div>
			</div>
		</div>
	</div>
</div>
</template>

<script>
export default {
	name: 'buy',
	data() {
		return {
			id:0,
			rules: [
		        value => !!value || '请输入要购买的数量'
		    ],
		    bank:{
		    	bank_name:'',
		    	account_name:'',
		    	account_number:'',
		    },
		    balance:0,
		    tips:'',
		    amount:0,
		    rate:1,
		    rmb:0,
		    imgsShow:[],
		    imgsPost:[]

		}
	},
	watch:{
		amount:function (value) {
			this.rmb = this.zmath.mul(this.rate, value)
		}
	},
	created() {
		this.id = this.$route.query.id
		this.init()
	},
	methods: {
		init:function () {
			this.get('api/index/exchange',{}).then((rs)=>{
				this.rate = rs.data.out
			})
			this.get('api/Agora/tradeInfo',{id:this.id}).then((rs)=>{
				this.balance = rs.data.balance
				this.bank = rs.data.bank
				this.tips = rs.data.tips
				//this.rate = rs.data.out
			})
		},
		//图片上传
		imgUpload:function (event) {
			var _this = this;
			event.preventDefault();
			let file = event.target.files[0];
			// 看支持不支持FileReader
			if (!file || !window.FileReader) return;
			if (/^image/.test(file.type)) {
				// 创建一个reader
				let reader = new FileReader();
				// 将图片将转成 base64 格式
				reader.readAsDataURL(file);
				// 读取成功后的回调
				reader.onloadend = function () {
					_this.imgsShow.push(this.result)
				}
			}
			var formData = new FormData();
			formData.append('file',file);
			formData.append('token',_this.getToken());
			_this.upload('api/member/upFile.html',formData).then((res) => {
				if (res.code==0) 
				{
					_this.imgsPost.push(res.data)
				}
				else
				{
					_this.$store.commit('layer',res.msg)
				}
			})
		},
		//提交
		onpost(){
			this.post('api/Agora/trade',{id:this.id,amount:this.amount,images:this.imgsPost}).then((rs)=>{
				this.$store.commit('layer',rs.msg)
				if (rs.code==0) {
					this.jump('/my/publishBuyRecord')
				}
			})
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.z-p{
	margin:10px 0px;
}
.z-p-describe {
	color: #8F8E8E;
	margin-bottom: 100px;
}
.z-buy-input {
	border-bottom: 1px solid #1E1F22;
	padding: 15px 10px;
}
.z-padding-both {
	padding: 0px 10px;
}
.z-buy-rmb {
	padding: 15px 0px;
	border-top: 1px solid #2F3135;
	border-bottom: 1px solid #2F3135;
	color: #8F8E8E;
}
.z-buy-imgs {
	display: flex;
	display: -webkit-flex;
	flex-wrap:wrap;
	flex-direction:row;
}
.z-buy-imgs div{
	position: relative;
	margin-right: 10px;
	margin-bottom: 10px;
}
.z-buy-imgs img,
.z-buy-imgs input{
	width: 100px;
	height: 100px;
}
.z-buy-imgs input {
	position:absolute;
	left:0;
	right:0;
	top:0;
	bottom:0;
	z-index:999;
	opacity:0;
}
.z-btn-box {
	position: fixed;
	left: 0;
	right: 0;
	bottom: 0;
	width: 100%;
	background: #20232A;
	border-top: 2px solid #1E1F22;
}
</style>



// WEBPACK FOOTER //
// src/pages/market/buy.vue